
<template>
  <Loader v-if="loader" />

  <div class="card p-3">
    <div class="grid cmor">
      <div class="col-12 lg:col-6">
        <label>Data emissione</label>
        <Calendar
          v-model="selectedDate"
          selectionMode="range"
          :manualInput="false"
          dateFormat="dd-mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="col-12 lg:col-6 flex align-items-end">
        <Button
          label="Cerca"
          @click="searchData"
          icon="pi pi-search"
          iconPos="left"
        />
      </div>
    </div>
  </div>
  <div v-show="selectedItems.length > 0" class="btn-selected mb-2">
    <Button
      @click="dialogBeforePecSent = !dialogBeforePecSent"
      class="p-button-warning p-3 m-1"
      style="min-width: 200px"
    >
      APRI PRE-INVIO CMOR ({{ selectedItems.length }})
      <i class="pi pi-table ml-5"></i>
    </Button>
  </div>

  <div v-if="items.some((el) => !el.pec && !el.email )">
    <Message severity="warn" class="bg-pink-100">
      Attenzione ({{items.filter(el => !el.pec && !el.email ).reduce(acc => acc + 1, 0)}}) forniture non hanno indirizzo di contatto 
    </Message>
    <div v-if="selectedItems.length > 0 && selectedItems.some((el) => !el.pec && !el.email )" class="mb-2">
      <Chip @click="removeItemsNoContacts" class="cursor-pointer bg-pink-100" label="Rimuovi selezione senza contatti" removable />
    </div>
  </div>

  <div class="table-cmor">
    <div
      class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end mb-2"
    >
      <span class="p-input-icon-left">
        <i class="pi pi-search" />
        <InputText
          type="search"
          v-model="filters['global'].value"
          placeholder="Cerca..."
        />
      </span>
    </div>
    <DataTable
      :value="items"
      v-model:selection="selectedItems"
      :paginator="true"
      :rows="50"
      :rowClass="rowClass"
      v-model:filters="filters"
      filterDisplay="row"
      :globalFilterFields=globalFilterFields
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50, 200, 500]"
      dataKey="numero"
      responsiveLayout="scroll"
      currentPageReportTemplate="{first} a {last} di {totalRecords}"
      editMode="cell" @cell-edit-complete="onCellDataInvioComplete"
    >
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template>
      <Column selectionMode="multiple" headerStyle="width: 3rem" />
      <Column field="numero" header="Fattura" :sortable="true" />
      <Column field="tipo_pagamento" header="Tipo Pagamento" :sortable="true" />
      <Column field="fornitura" header="Fornitura" :sortable="true" />
      <Column
        field="cliente"
        header="Cliente"
        :showFilterMenu="false"
        :filterMenuStyle="{ width: '14rem' }"
        style="min-width: 12rem"
        :sortable="true"
      >
        <template #body="{ data }">
          {{ data.cliente }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <MultiSelect
            v-model="filterModel.value"
            @change="filterCallback()"
            :options="lists['cliente']"
            filter
            optionLabel="name"
            optionValue="name"
            placeholder="Filtra per cliente"
            class="p-column-filter"
            style="min-width: 12rem"
            :showClear="true"
          >
            <template #option="slotProps">
              {{ slotProps.option.name }}  <Badge class="ml-2 surface-300" :value="items.filter(el => el['cliente'] == slotProps.option.name ).reduce(acc => acc + 1, 0)"></Badge>
            </template>
          </MultiSelect>
        </template>
      </Column>
      <!-- <Column field="pec" header="Pec" :sortable="true" />
      <Column field="email" header="Email" :sortable="true" /> -->
      <Column header="Contatto" >
        <template #body="{ data }">
          {{ data.pec > "" ? data.pec : data.email }}
        </template>
      </Column>
      <Column field="totale_fattura" header="Tot Fattura" :sortable="true">
        <template #body="{ data }">
          {{ data.totale_fattura.toFixed(2) }}
        </template>
      </Column>
      <Column field="pagato" header="Tot Pagato" :sortable="true">
        <template #body="{ data }">
          {{ data.pagato.toFixed(2) }}
        </template>
      </Column>
      <Column field="saldo" header="Tot Saldo" :sortable="true">
        <template #body="{ data }">
          {{ data.saldo.toFixed(2) }}
        </template>
      </Column>
      <Column field="cmor_tot" header="Tot cmor" :sortable="true">
        <template #body="{ data }">
          {{ data.cmor_tot.toFixed(2) }}
        </template>
      </Column>
      <Column
        field="data_emissione"
        header="Data Emissione"
        :sortable="true"
        style="min-width: 110px"
      >
        <template #body="{ data }">
          {{ formatDate(data.data_emissione) }}
        </template>
      </Column>
      <Column
        field="data_scadenza"
        header="Data Scadenza"
        :sortable="true"
        style="min-width: 110px"
      >
        <template #body="{ data }">
          {{ formatDate(data.data_scadenza) }}
        </template>
      </Column>
      <Column field="data_invio" header="Data Invio" :sortable="true" style="min-width: 110px">
        <template #body="{ data }">
          {{ data.data_invio != null ? formatDate(data.data_invio) : '' }}
        </template>
        <template #editor="{ data }">
          <Calendar v-model="data.data_invio" dateFormat="dd-mm-yy"  showIcon class="inputfield w-full mt-1"/> 
        </template>
      </Column>
      <Column
        field="rappresentante"
        header="Rappresentante"
        :showFilterMenu="false"
        :filterMenuStyle="{ width: '14rem' }"
        style="min-width: 12rem"
        :sortable="true"
      >
        <template #body="{ data }">
          {{ data.rappresentante }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <MultiSelect
            v-model="filterModel.value"
            @change="filterCallback()"
            :options="lists['rappresentante']"
            filter
            optionLabel="name"
            optionValue="name"
            placeholder="Filtra per rappresentante"
            class="p-column-filter"
            style="min-width: 12rem"
            :showClear="true"
          >
            <template #option="slotProps">
              {{ slotProps.option.name }}
            </template>
          </MultiSelect>
        </template>
      </Column>
      <Column
        field="agente"
        header="Agente"
        :showFilterMenu="false"
        :filterMenuStyle="{ width: '14rem' }"
        style="min-width: 12rem"
        :sortable="true"
      >
        <template #body="{ data }">
          {{ data.agente }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <MultiSelect
            v-model="filterModel.value"
            @change="filterCallback()"
            :options="lists['agente']"
            filter
            optionLabel="name"
            optionValue="name"
            placeholder="Filtra per agente"
            class="p-column-filter"
            style="min-width: 12rem"
            :showClear="true"
          >
            <template #option="slotProps">
              {{ slotProps.option.name }}
            </template>
          </MultiSelect>
        </template>
      </Column>
    </DataTable>
  </div>

  <!-- Dialog precheck pec -->
  <Dialog
    header="Riepilogo Invio"
    v-model:visible="dialogBeforePecSent"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '85vw' }"
    :modal="true"
  >
    <div class="w-full">
      <InlineMessage severity="info" class="px-4 m-2">Totale invii: <b>{{tot_grouped_clients}}</b> </InlineMessage>
      <InlineMessage severity="info" class="px-4 m-2">Pec da inviare: <b>{{tot_grouped_clients_type_mail('pec')}}</b> </InlineMessage>
      <InlineMessage severity="info" class="px-4 m-2">Email da inviare: <b>{{(tot_grouped_clients) - (tot_grouped_clients_type_mail('pec'))}}</b> </InlineMessage>
      <InlineMessage severity="info" class="px-4 m-2">Fatture da inviare: <b>{{selectedItems.length}}</b> </InlineMessage>
      <InlineMessage :severity="selectedItems.filter(el => !el.pec && !el.email ).reduce(acc => acc + 1, 0) > 0 ? 'error' : 'info'" class="px-4 m-2">Forniture senza contatto: <b>{{selectedItems.filter(el => !el.pec && !el.email ).reduce(acc => acc + 1, 0)}}</b> </InlineMessage>
      <div v-if="selectedItems.some((el) => !el.pec )">
        <Message severity="warn" class="bg-surface-200">
          Alcune comunicazioni cmor saranno inviate con posta ordinaria
        </Message>
      </div>
      <div v-if="selectedItems.some( (el) => el.data_invio && moment(el.data_invio).isAfter( moment().subtract(30, 'days')) )">
        <Message severity="warn" class="bg-surface-200">
          Alcune comunicazioni cmor sono già state inviate negli ultimi 30gg
        </Message>
      </div>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        @click="dialogBeforePecSent = false"
        class="p-button-text p-button-secondary"
      />
      <Button
        label="Invia Ora"
        icon="pi pi-check"
        @click="sendPecInvoicesWithCmor"
        class="p-button-text p-button-primary"
      />
    </template>
  </Dialog>

  <!-- Dialog report pec sent -->
  <Dialog
    header="Controllo Invii"
    v-model:visible="dialogCheckPecSent"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '70vw' }"
  >
    <div class="w-full">
      <DataTable :value="report" responsiveLayout="scroll">
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
        <Column header="Contatto" :sortable="true">
          <template #body="{ data }">
            {{data.pec ?? data.email}}
          </template>
        </Column>
        <Column field="sent" header="Inviata" :sortable="true">
          <template #body="{ data, field }">
            <span v-if="data[field] == true" class="text-green-400">SI</span>
            <span v-else class="p-error">NO</span>
          </template>
        </Column>
        <Column field="sent_err" header="Errore"></Column>
      </DataTable>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        @click="dialogCheckPecSent = false"
        class="p-button-text"
      />
    </template>
  </Dialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Service from "@/services/ask-pratiche/pratiche-service";
import CmorService from "@/services/ask-management/cmor-fatture-clienti-service";
import { ref, getCurrentInstance, computed } from "vue";
import Loader from "@/components/Loader.vue";
import moment from "moment";
import { useToast } from "primevue/usetoast";

export default {
  components: {
    Loader,
  },
  setup() {
    const loader = ref(false);
    const globalFilterFields = ['numero','cliente','agente','pec','fornitura','email','rappresentante','agente.name', 'rappresentante.name', 'cliente.name']
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      agente: { value: null, matchMode: FilterMatchMode.IN },
      rappresentante: { value: null, matchMode: FilterMatchMode.IN },
      cliente: { value: null, matchMode: FilterMatchMode.IN },
    });
    const lists = ref({});
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const service = new Service(self.$http, self.$eventBus);
    const serviceMessaInMora = new CmorService(
      self.$http,
      self.$eventBus
    );
    const toast = useToast();
    const items = ref([]);
    const report = ref();
    const selectedItems = ref([]);
    const selectedDate = ref([
      moment().startOf("month").toDate(),
      moment().endOf("month").toDate(),
    ]);
    const dialogBeforePecSent = ref(false);
    const dialogCheckPecSent = ref(false);

    const searchData = () => {
      loader.value = true;
      let dates = [];
      if (selectedDate.value[0]) {
        dates[0] = moment(selectedDate.value[0]).format("YYYY-MM-DD");
        dates[1] = moment(selectedDate.value[0]).format("YYYY-MM-DD");
      }
      if (selectedDate.value[1]) {
        dates[1] = moment(selectedDate.value[1]).format("YYYY-MM-DD");
      }
      service.getInvoicesWithCmor(dates)
        .then((res) => {
          items.value = res.items;
          populateListFields(res.items);
        })
        .finally(() => {
          loader.value = false;
        });
    };

    const populateListFields = (items) => {

      globalFilterFields.forEach(fieldObj => {
        let field = fieldObj.split(".")[0]
        let prop = fieldObj.split(".")[1]
        
        lists.value[field] = []
        let list = [];
        if (items.length > 0) {
          items.forEach((el) => {
            if (el[field]) {
              list.push({ [prop]: el[field] });
            }
          });
          lists.value[field] = Array.from(new Map(list.map(item => [item[prop], item])).values());
        }
      });

    };

    const sendPecInvoicesWithCmor = () => {
      if (validateContacts()) {
        dialogBeforePecSent.value = false;
        dialogCheckPecSent.value = false;
        loader.value = true;
        serviceMessaInMora.sendPecInvoicesWithCmor(selectedItems.value)
          .then((res) => {
            dialogCheckPecSent.value = true;
            report.value = res.items;
            console.log(report.value);
            //toast.add({severity:'success', summary: 'Successo', detail:`${res.items.length} pec inviate`});
          })
          .finally(() => {
            loader.value = false;
          });
      } else {
        toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Alcune forniture non hanno indirizzo di contatto",
          life: 5000
        });
      }
    };

    const rowClass = (data) => {
      return [{ "bg-pink-100": !data.pec && !data.email }];
    };

    const validateContacts = () => {
      let isValid = selectedItems.value.every((el) => el.pec || el.email);
      return isValid;
    };

    const removeItemsNoContacts = () => {
      selectedItems.value = selectedItems.value.filter((el) => el.pec || el.email)
    }

    const tot_grouped_clients = computed(() => {
      
      const objGrouped = selectedItems.value.reduce((acc, item) => {
        const key = item.rappresentante || item.cliente;
        if (!acc.includes(key)) {
            acc.push(key)
        }

        return acc;
      }, []);

      return objGrouped.length;
    });

    const tot_grouped_clients_type_mail = (type_mail) => {
      let totContacts = [];
      selectedItems.value.forEach(el => {
        if (el[type_mail] != "" && el[type_mail] != null && !totContacts.includes(el[type_mail])) {
          totContacts.push(el[type_mail])
        }
      });
      return totContacts.length

    };

    const onCellDataInvioComplete = (event) => {
      let { newValue, index, field, newData } = event;
      if (newValue != null) {
        loader.value = true;
        let data = moment(newValue).format('YYYY-MM-DD')
        newData[field] = data
        service.updateDataInvioToCmorSent(newData)
        .then(() => {
          items.value[index] = newData
        })
        .finally(() => {
          loader.value = false;
        });
        
      }
      
    }

    return {
      globalFilterFields,
      loader,
      formatDate,
      filters,
      searchData,
      selectedDate,
      lists,
      items,
      report,
      selectedItems,
      sendPecInvoicesWithCmor,
      rowClass,
      dialogBeforePecSent,
      dialogCheckPecSent,
      removeItemsNoContacts,
      tot_grouped_clients,
      tot_grouped_clients_type_mail,
      onCellDataInvioComplete,
      moment,
    };
  },
};
</script>
<style scoped>
.btn-selected {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 2;
}
.cmor {
  justify-content: space-between !important;
}
</style>
